import { render, staticRenderFns } from "./coupons.vue?vue&type=template&id=3a31f238&scoped=true&"
import script from "./coupons.ts?vue&type=script&lang=ts&"
export * from "./coupons.ts?vue&type=script&lang=ts&"
import style0 from "./coupons.scss?vue&type=style&index=0&id=3a31f238&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a31f238",
  null
  
)

export default component.exports